var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestroomwheelchair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 2 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 19 13 v -2 c -1.54 0.02 -3.09 -0.75 -4.07 -1.83 l -1.29 -1.43 c -0.17 -0.19 -0.38 -0.34 -0.61 -0.45 c -0.01 0 -0.01 -0.01 -0.02 -0.01 H 13 c -0.35 -0.2 -0.75 -0.3 -1.19 -0.26 C 10.76 7.11 10 8.04 10 9.09 V 15 c 0 1.1 0.9 2 2 2 h 5 v 5 h 2 v -5.5 c 0 -1.1 -0.9 -2 -2 -2 h -3 v -3.45 c 1.29 1.07 3.25 1.94 5 1.95 Z m -6.17 5 c -0.41 1.16 -1.52 2 -2.83 2 c -1.66 0 -3 -1.34 -3 -3 c 0 -1.31 0.84 -2.41 2 -2.83 V 12.1 c -2.28 0.46 -4 2.48 -4 4.9 c 0 2.76 2.24 5 5 5 c 2.42 0 4.44 -1.72 4.9 -4 h -2.07 Z M10,4a2,2 0 1,0 4,0a2,2 0 1,0 -4,0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestroomwheelchair);
export default __webpack_public_path__ + "static/media/restroom.wheelchair.4e5de44737336b72ce7672b3eef64b49.svg";
export { ForwardRef as ReactComponent };